<article class="cui-card input-parameter-node">
  <header class="cui-card__header input-parameter-node__header">
    <span class="material-symbols-outlined">tune</span><strong>Parameters</strong>
  </header>
  <div class="input-parameter-node__content">
    <app-execution-form
      [tool]="tool()"
      [outputsToMap]="outputsToMap()"
      [submitting]="submitting()"
      (formSubmitted)="onSubmit($event)"></app-execution-form>
  </div>
</article>
